export class Funcionario {
  matricula: string;
  nome: string;
  login: string;
  email: string;
}
